import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { BsFillPersonLinesFill } from "react-icons/bs";
import {AiOutlinePhone} from "react-icons/ai"
import resume from "../assets/Resume.pdf"
import styles from './statistics.module.css'

const SocialLinks = () => {
  const links = [
    {
      id: 1,
      child: (
        <>
           <FaLinkedin size={30} />LinkedIn
        </>
      ),
      href: "https://www.linkedin.com/in/chetan-sharma2812/",
      style: "rounded-tr-md",
    },
    {
      id: 2,
      child: (
        <>
           <FaGithub size={30} />GitHub
        </>
      ),
      href: "https://github.com/cs2812",
    },
    {
      id: 3,
      child: (
        <>
           <HiOutlineMail size={30} />Email
        </>
      ),
      href: "mailto:chetansharma3035@gmail.com",
    },
    {
      id: 4,
      child: (
        <>
          <AiOutlinePhone size={30} />Mobile 
        </>
      ),
      href:"tel:+7062831262",
    },
    {
      id: 5,
      child: (
        <>
          <BsFillPersonLinesFill size={30} /> Resume
        </>
      ),
      href: resume,
      download: true,
    }
  ];

  return (
    
    <div className={styles.socialMain}>
      <div className={styles.socialM}>
        {links.map(({ id, child, href, style, download }) => (
          <div key={id} className={styles.socialDiv}>
            
            <a
              href={href}
              className={styles.socialA}
              download={download}
              target="_blank"
              rel="noreferrer"
            >
              {child}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SocialLinks;
